const dbShopBundle = require("../../../../shared/data/dbShopBundle.json");
const {
	$each,
	$find,
	hasClass,
	toggleClass,
	onClickOrEnter,
	setInnerHtmlIfDiff,
	compileTemplate,
	scrollToEl,
	onEnter,
	sendDataLayerEvent,
} = require("./ElevHelpers");
const {
	loadCartFromStorage,
	getItemsForSubType,
	modifyCart,
	removeItemFromCart,
	addItemsToCart,
	showAddToCartModal,
	getItemTypeFromSku,
} = require("./CartUtil");
const {setupModalButton} = require("./ModalUtil");
const {validateSubs} = require("./EnrollHelpers");
const ElevShared = require("../../../../shared/ElevShared");
const ElevPrices = require("./ElevPrices");

const {MAX_SUBS} = require("../../../../shared/Constants");

//
// JS for Enroll
//

function setupEnrollPage(page) {
	// Data

	const priceInfo = {
		monthly: {
			unit: "month",
			shortUnit: "mo",
		},
		yearly: {
			unit: "year",
			shortUnit: "yr",
		},
	};

	const state = {
		selectedOptionIndex: -1,
		hasAttemptedSubmit: false, // Only validate after an attempt to submit
		newSubs: [],
		cartSubs: [],
	};

	// Element refs
	const optionsContainer = page.querySelector(
		".ba11-p-enroll-subscriptionOptions"
	);
	const subscriptionOptions = optionsContainer.querySelectorAll(
		".ba11-subscription-option"
	);
	const stepTwo = page.querySelector(".step-two");
	const cartRowsContainer = page.querySelector(
		".ba11-p-enroll-subs-rows-in-cart-container"
	);
	const newSubRowsContainer = page.querySelector(
		".ba11-p-enroll-subs-rows-container"
	);
	const addRow = page.querySelector(".ba11-p-enroll-sub-add-row");
	const subtotalLine = page.querySelector(".ba11-p-enroll-subs-subtotal");
	const addToCartButton = page.querySelector(".ba11-p-enroll-subs-add-to-cart");
	const subRowTemplate = compileTemplate("#enrollSubRowTemplate");

	// Helper funcs

	const getSubTypeFromSelectedIndex = function(index) {
		if (
			typeof index !== "number" ||
			index < 0 ||
			index >= subscriptionOptions.length
		)
			return;
		return subscriptionOptions[index].getAttribute("data-subscription-type");
	};

	const getSubCount = function() {
		return state.newSubs.length + state.cartSubs.length;
	};

	const getCountOfSubType = function(subType) {
		let count = 0;
		for (let i = 0; i < state.cartSubs.length; i++) {
			if (state.cartSubs[i].subType === subType) count++;
		}
		for (let i = 0; i < state.newSubs.length; i++) {
			if (state.newSubs[i].subType === subType) count++;
		}
		return count;
	};

	const getItemsForSub = function(sub) {
		return getItemsForSubType(sub.subType, sub.name, sub.selectedBundles);
	};

	// Given an array of sub objects, like in state.cartSubs or state.newSubs,
	// mutates the array adding actualPrice and basePrice fields to each and
	// returns it.
	const getSubsWithPrices = function(subs) {
		// All items for all subscriptions.
		const items = [];
		// Some subscriptions, like bundles, expand into multiple items. This array
		// will have as many elements as subs, and will give the items index where
		// the items for that subscription starts. It will also get one more
		// element at the end equal to items.length to make using it easier.
		const itemStartIndices = [];

		subs.forEach(s => {
			itemStartIndices.push(items.length);
			const sItems = getItemsForSub(s);
			sItems.forEach(item => items.push(item));
		});
		itemStartIndices.push(items.length);

		const itemsWithPrices = ElevPrices.calculateItemPrices(items);
		const itemsWithBasePrices = ElevPrices.calculateItemPrices(items, {
			skipDiscounts: true,
		});

		return subs.map((s, i) => {
			const start = itemStartIndices[i];
			const end = itemStartIndices[i + 1];
			const actualItems = itemsWithPrices.slice(start, end);
			const actualPrice = actualItems.reduce(
				(acc, item) => acc + item.price,
				0
			);
			s.actualPrice = ElevPrices.finishPrice(actualPrice);
			const baseItems = itemsWithBasePrices.slice(start, end);
			const basePrice = baseItems.reduce((acc, item) => acc + item.price, 0);
			s.basePrice = ElevPrices.finishPrice(basePrice);
			return s;
		});
	};

	const getAddRowPrice = function(subType) {
		const currentSubs = state.cartSubs.concat(state.newSubs);
		const addedSampleSub = {subType, name: "name", selectedBundles: [3]};
		const fullSubs = currentSubs.concat([addedSampleSub]);
		const fullSubsPrices = getSubsWithPrices(fullSubs);
		const addTotal = fullSubsPrices[currentSubs.length].actualPrice;

		if (subType === "bundle") {
			return addTotal.toFixed(2);
		}
		return addTotal.toFixed(2) + `/${priceInfo[subType].unit}`;
	};

	// Must pass a subscription that was returned from getSubsWithPrices.
	const getRowPriceText = function(sub, useBase) {
		const {subType, actualPrice, basePrice} = sub;
		const price = useBase ? basePrice : actualPrice;
		if (subType === "bundle") return price.toFixed(2);
		return `${price.toFixed(2)}/${priceInfo[subType].shortUnit}`;
	};

	const getBundleDetailsText = function(sub) {
		if (sub.selectedBundles && sub.selectedBundles.length) {
			const count = sub.selectedBundles.length;
			if (count === 1) return `BA ${sub.selectedBundles[0]} + 1 yr BA Online`;
			let consecutive = count > 1;
			// Since we're only sorting simple things here, default sort is fine
			for (let i = 1; i < count; i++) {
				if (sub.selectedBundles[i] - sub.selectedBundles[i - 1] !== 1) {
					consecutive = false;
					break;
				}
			}
			if (consecutive) {
				const min = sub.selectedBundles[0];
				const max = sub.selectedBundles[count - 1];
				return `BA ${min}-${max} + ${count} yrs BA Online`;
			} else {
				const list = sub.selectedBundles.join(", ");
				return `BA ${list} + ${count} yrs BA Online`;
			}
		} else {
			return "Select bundle(s)";
		}
	};

	const getNextAvatarIndex = function() {
		const usedIndices = [];
		for (let i = 0; i < state.cartSubs.length; i++) {
			usedIndices.push(state.cartSubs[i].avatarIndex);
		}
		for (let i = 0; i < state.newSubs.length; i++) {
			usedIndices.push(state.newSubs[i].avatarIndex);
		}
		for (let i = 1; i <= MAX_SUBS; i++) {
			if (!usedIndices.includes(i)) return i;
		}
	};

	const getErrorMessage = function(errorCode) {
		return `* ${ElevShared.copyForStudentNameErrors(errorCode)}.`;
	};

	// Sub Row

	const getSubRowHTML = function(sub) {
		const handlebarsVars = {
			subType: sub.subType,
			name: sub.name,
			fromCart: !!sub.fromCart,
			avatarIndex: sub.avatarIndex,
		};

		if (sub.subType === "bundle") {
			handlebarsVars.bundle = true;
			handlebarsVars.bundleDetailsText = getBundleDetailsText(sub);
		}
		return subRowTemplate(handlebarsVars);
	};

	const setupSubRow = function(sub, container) {
		// Avatar index starts at 1, so no need to worry about misreading 0 as false
		sub.avatarIndex = sub.avatarIndex || getNextAvatarIndex();
		sub.name = sub.name || "";
		sub.errors = sub.errors || [];
		const rowEl = document.createElement("div");
		const className = sub.fromCart
			? "ba11-p-enroll-sub-row sub-row-static"
			: "ba11-p-enroll-sub-row";
		rowEl.setAttribute("class", className);
		rowEl.innerHTML = getSubRowHTML(sub);
		if (!sub.fromCart) {
			container.insertBefore(
				rowEl,
				container.children[container.children.length - 1]
			);
		} else {
			container.appendChild(rowEl);
		}
		sub.el = rowEl;
		if (!sub.fromCart) {
			state.newSubs.push(sub);

			// Name event listeners
			sub.el.querySelector("input").addEventListener("input", evt => {
				sub.name = evt.target.value;
				validateSubs(state);
				update();
			});
			setupModalButton(
				sub.el.querySelector(".ba11-p-enroll-sub-info-icon.name-info")
			);

			// Bundle
			if (sub.subType === "bundle") {
				sub.selectedBundles = sub.selectedBundles || [];
				const dropdown = rowEl.querySelector(
					".ba11-p-enroll-sub-row-bundle-dropdown"
				);
				const dropdownContainer = rowEl.querySelector(
					".ba11-p-enroll-sub-row-bundle-dropdown-container"
				);
				const dropdownOptions = rowEl.querySelector(
					".ba11-p-enroll-sub-row-bundle-dropdown-options"
				);
				const options = $find(
					dropdownOptions,
					".ba11-p-enroll-sub-row-bundle-dropdown-option"
				);
				const dropdownPreview = rowEl.querySelector(
					".ba11-p-enroll-sub-row-bundle-dropdown-preview"
				);
				if (!sub.selectedBundles.length)
					toggleClass(dropdownPreview, "--placeholder", true);
				setupModalButton(
					sub.el.querySelector(".ba11-p-enroll-sub-info-icon.bundle-info")
				);

				// Prefill any selected bundles (saved when you switch between sub types)
				$each(
					dropdown,
					".ba11-p-enroll-sub-row-bundle-dropdown-option",
					opt => {
						const grade = parseInt(opt.getAttribute("data-grade"));
						if (sub.selectedBundles.includes(grade)) {
							toggleClass(opt, "--selected", true);
						}
					}
				);

				const closeDropdown = function() {
					toggleClass(dropdownContainer, "ba11--hidden", true);
					toggleClass(dropdown, "--active", false);
					$each(
						dropdown,
						".ba11-p-enroll-sub-row-bundle-dropdown-options",
						opt => {
							toggleClass(opt, "--active", false);
						}
					);
				};

				const openDropdown = function() {
					toggleClass(dropdownContainer, "ba11--hidden", false);
					toggleClass(dropdown, "--active", true);
				};

				const toggleOptionSelected = function(el) {
					const grade = parseInt(el.getAttribute("data-grade"));
					if (hasClass(el, "--selected")) {
						toggleClass(el, "--selected", false);
						const bundleIndex = sub.selectedBundles.indexOf(grade);
						if (bundleIndex !== -1) sub.selectedBundles.splice(bundleIndex, 1);
						if (!sub.selectedBundles.length)
							toggleClass(dropdownPreview, "--placeholder", true);
					} else {
						toggleClass(el, "--selected", true);
						sub.selectedBundles.push(grade);
						sub.selectedBundles.sort();
						toggleClass(dropdownPreview, "--placeholder", false);
					}
					setInnerHtmlIfDiff(dropdownPreview, getBundleDetailsText(sub));
					validateSubs(state);
					update();
				};

				const setActiveOptionByIndex = function(optIndex) {
					options.forEach((opt, i) => {
						if (i === optIndex) {
							toggleClass(opt, "--active", true);
						} else {
							toggleClass(opt, "--active", false);
						}
					});
				};

				options.forEach((opt, optIndex) => {
					opt.addEventListener("mouseenter", () => {
						setActiveOptionByIndex(optIndex);
					});
				});
				dropdown.addEventListener("click", evt => {
					if (hasClass(dropdownContainer, "ba11--hidden")) {
						openDropdown();
					} else {
						if (dropdown.contains(evt.target)) {
							for (let i = 0; i < dropdownOptions.children.length; i++) {
								const option = dropdownOptions.children[i];
								if (evt.target === option || option.contains(evt.target)) {
									toggleOptionSelected(option);
									return;
								}
							}
						}
						closeDropdown();
					}
				});
				dropdown.addEventListener("blur", evt => {
					closeDropdown();
				});
				dropdown.addEventListener("keydown", evt => {
					let activeOptionIndex = -1;
					for (let i = 0; i < options.length; i++) {
						if (hasClass(options[i], "--active")) {
							activeOptionIndex = i;
							break;
						}
					}
					if (
						evt.key === "Escape" ||
						evt.code === "Escape" ||
						evt.which === 27
					) {
						options.forEach(opt => toggleClass(opt, "--active", false));
						closeDropdown();
					} else if (
						evt.key === "Enter" ||
						evt.code === "Enter" ||
						evt.which === 13
					) {
						if (hasClass(dropdownContainer, "ba11--hidden")) {
							openDropdown();
						} else {
							if (activeOptionIndex > -1) {
								toggleOptionSelected(options[activeOptionIndex]);
							}
						}
					} else if (
						evt.key === "ArrowDown" ||
						evt.code === "ArrowDown" ||
						evt.which === 40
					) {
						if (activeOptionIndex !== options.length - 1) {
							setActiveOptionByIndex(activeOptionIndex + 1);
						}
						evt.preventDefault();
					} else if (
						evt.key === "ArrowUp" ||
						evt.code === "ArrowUp" ||
						evt.which === 38
					) {
						if (activeOptionIndex !== 0) {
							setActiveOptionByIndex(activeOptionIndex - 1);
						}
						evt.preventDefault();
					}
				});
			}
		}

		// Set up delete
		const deleteFunc = function(evt) {
			container.removeChild(sub.el);
			if (sub.fromCart) {
				modifyCart(c => {
					const itemsToRemove = getItemsForSubscription(sub);
					sendDataLayerEvent("remove_from_cart", {
						items: itemsToRemove.map(item => {
							return {
								item_id: item.sku,
								item_category: getItemTypeFromSku(item.sku),
								quantity: 1,
							};
						}),
					});
					itemsToRemove.forEach(item => removeItemFromCart(item, 1, c));
				});
			}
			const subArray = sub.fromCart ? state.cartSubs : state.newSubs;
			const subIndex = subArray.indexOf(sub);
			if (subIndex !== -1) subArray.splice(subIndex, 1);
			update();
		};
		const deleteIcon = sub.el.querySelector(
			".ba11-p-enroll-sub-row-delete-container"
		);
		onClickOrEnter(deleteIcon, deleteFunc);
	};

	// Subscription Actions

	const createSubscription = function(sub) {
		setupSubRow(sub, newSubRowsContainer);
		update();
	};

	const modifySubscription = function(subType) {
		// Gather data about the last row
		const lastNewSub = state.newSubs[state.newSubs.length - 1];
		const {selectedBundles, name, avatarIndex} = lastNewSub;

		// Remove last sub row
		newSubRowsContainer.removeChild(lastNewSub.el);
		state.newSubs.pop();

		// Add row with new subType
		createSubscription({subType, name, selectedBundles, avatarIndex});
	};

	const addSubscription = function(subType) {
		if (getSubCount() < MAX_SUBS) {
			const sub = {subType};
			setupSubRow(sub, newSubRowsContainer);
		}
		update();
	};

	const update = function() {
		const subCount = getSubCount();

		// Empty message
		const emptyMessage = page.querySelector(".ba11-p-enroll-subs-empty");
		toggleClass(
			emptyMessage,
			"ba11--hidden",
			subCount > 0 || state.selectedOptionIndex > -1
		);

		// Cart rows
		const cartTitle = page.querySelector(
			".ba11-p-enroll-subs-rows-in-cart-title"
		);
		toggleClass(cartTitle, "ba11--hidden", state.cartSubs.length === 0);
		toggleClass(cartRowsContainer, "ba11--hidden", state.cartSubs.length === 0);

		// New sub rows
		const subRowsTitle = page.querySelector(".ba11-p-enroll-subs-title");
		toggleClass(
			subRowsTitle,
			"ba11--hidden",
			subCount === 0 && state.selectedOptionIndex === -1
		);
		const subTitleDivider = page.querySelector(
			".ba11-p-enroll-subs-title-divider"
		);
		toggleClass(
			subTitleDivider,
			"ba11--hidden",
			state.cartSubs.length === 0 || subCount === 0
		);

		// New sub rows - error messages
		for (let i = 0; i < state.newSubs.length; i++) {
			const sub = state.newSubs[i];
			const nameInput = sub.el.querySelector(
				".ba11-p-enroll-sub-row-input-name"
			);
			const nameErrorEl = sub.el.querySelector(
				".ba11-p-enroll-sub-row-input-error"
			);
			const bundleDropdownEl = sub.el.querySelector(
				".ba11-p-enroll-sub-row-bundle-dropdown"
			);
			const bundleErrorEl = sub.el.querySelector(
				".ba11-p-enroll-sub-row-bundle-dropdown-error"
			);

			const errors = [...sub.errors]; // clone simple text values

			// Account for bundle with no grades selected
			if (sub.subType === "bundle") {
				if (errors.includes("E_NO_GRADE")) {
					toggleClass(bundleErrorEl, "ba11--hidden", false);
					toggleClass(bundleDropdownEl, "--error", true);
					setInnerHtmlIfDiff(bundleErrorEl, getErrorMessage("E_NO_GRADE"));
					errors.splice(errors.indexOf("E_NO_GRADE"), 1);
				} else {
					toggleClass(bundleErrorEl, "ba11--hidden", true);
					toggleClass(bundleDropdownEl, "--error", false);
				}
			}

			// Then deal with other errors
			if (errors.length)
				setInnerHtmlIfDiff(nameErrorEl, getErrorMessage(errors[0]));
			toggleClass(nameErrorEl, "ba11--hidden", !errors.length);
			toggleClass(nameInput, "--error", errors.length);
		}

		// Empty new subs with cart subs message
		const emptyNewSubsWithCartMessage = page.querySelector(
			".ba11-p-enroll-subs-title-empty-with-cart"
		);
		toggleClass(
			emptyNewSubsWithCartMessage,
			"ba11--hidden",
			state.cartSubs.length === 0 ||
				state.newSubs.length > 0 ||
				state.selectedOptionIndex > -1
		);

		// All rows
		const subscriptionsContainer = page.querySelector(".ba11-p-enroll-subs");
		$each(
			subscriptionsContainer,
			".ba11-p-enroll-sub-row-delete-container",
			deleteIcon => {
				const onlySingleNewSub = subCount === 1 && state.newSubs.length === 1;
				toggleClass(deleteIcon, "ba11--hidden", onlySingleNewSub);
				if (onlySingleNewSub) {
					if (deleteIcon.getAttribute("tabindex"))
						deleteIcon.removeAttribute("tabindex");
				} else {
					if (!deleteIcon.getAttribute("tabindex"))
						deleteIcon.setAttribute("tabindex", 0);
				}
			}
		);
		const subs = getSubsWithPrices(state.cartSubs.concat(state.newSubs));
		subs.forEach(s => {
			const hasDiscount = s.basePrice > s.actualPrice;
			const basePriceEl = s.el.querySelector(
				".ba11-p-enroll-sub-row-base-price"
			);
			const basePriceSpan = s.el.querySelector(
				".ba11-p-enroll-sub-row-base-price-text"
			);
			if (hasDiscount) {
				setInnerHtmlIfDiff(basePriceSpan, getRowPriceText(s, true));
			}
			toggleClass(basePriceEl, "ba11--hidden", !hasDiscount);

			const actualPriceSpan = s.el.querySelector(
				".ba11-p-enroll-sub-row-price-text"
			);
			setInnerHtmlIfDiff(actualPriceSpan, getRowPriceText(s, false));
		});

		// Add row
		toggleClass(addRow, "ba11--hidden", state.selectedOptionIndex === -1);
		const selectedSubType = getSubTypeFromSelectedIndex(
			state.selectedOptionIndex
		);

		const addRowText = page.querySelector(".ba11-p-enroll-sub-add-row-text");
		toggleClass(addRowText, "ba11--hidden", subCount === MAX_SUBS);
		const addRowMaxedText = page.querySelector(
			".ba11-p-enroll-sub-add-row-text-maxed"
		);
		toggleClass(addRowMaxedText, "ba11--hidden", subCount !== MAX_SUBS);
		const addRowContent = page.querySelector(
			".ba11-p-enroll-sub-add-row-content"
		);
		toggleClass(addRowContent, "--maxed", subCount === MAX_SUBS);

		const addRowArticle = page.querySelector(
			".ba11-p-enroll-sub-add-row-article"
		);
		const article =
			getCountOfSubType(selectedSubType) === 0 || selectedSubType === "bundle"
				? "a"
				: "another";
		setInnerHtmlIfDiff(addRowArticle, article);

		if (state.selectedOptionIndex > -1) {
			const subTypeTextSpan = addRow.querySelector(
				".ba11-p-enroll-sub-add-row-type"
			);
			setInnerHtmlIfDiff(subTypeTextSpan, selectedSubType);
			const priceTextSpan = addRow.querySelector(
				".ba11-p-enroll-sub-add-row-price"
			);
			setInnerHtmlIfDiff(priceTextSpan, getAddRowPrice(selectedSubType));
		}

		// Subtotal
		toggleClass(
			subtotalLine,
			"ba11--hidden",
			state.newSubs.length === 0 && state.selectedOptionIndex === -1
		);
		let subtotal = 0;
		for (let i = 0; i < subs.length; i++) {
			subtotal += subs[i].actualPrice;
		}
		subtotal = ElevPrices.finishPrice(subtotal);
		const subtotalPriceTextSpan = page.querySelector(
			".ba11-p-enroll-subs-subtotal-price-text"
		);
		setInnerHtmlIfDiff(subtotalPriceTextSpan, subtotal.toFixed(2));

		// Add to Cart button
		toggleClass(
			addToCartButton,
			"ba11--hidden",
			subCount === 0 && state.selectedOptionIndex === -1
		);
		if (state.cartSubs.length) {
			if (state.newSubs.length) {
				setInnerHtmlIfDiff(addToCartButton, "Update Cart");
			} else {
				setInnerHtmlIfDiff(addToCartButton, "Go to Cart");
			}
		} else {
			setInnerHtmlIfDiff(addToCartButton, "Add to Cart");
		}
	};

	// Initial setup

	const initialSetup = function() {
		const cart = loadCartFromStorage();

		if (cart) {
			const items = cart.items;
			const bundleSubsByName = {};

			for (let i = 0; i < items.length; i++) {
				const item = items[i];
				const name = item.options.displayName;
				if (item.sku === "beast-monthly") {
					state.cartSubs.push({
						subType: "monthly",
						name,
						fromCart: true,
						errors: [],
					});
				} else if (item.sku === "beast-yearly") {
					const bundleID = item.options.bundleID;
					if (bundleID) {
						const bundleGrade = parseInt(bundleID.substring(13));
						const existingBundleSub = bundleSubsByName[name];
						if (existingBundleSub) {
							existingBundleSub.selectedBundles.push(bundleGrade);
						} else {
							// create sub
							const sub = {
								subType: "bundle",
								name,
								fromCart: true,
								selectedBundles: [bundleGrade],
								errors: [],
							};
							state.cartSubs.push(sub);
							bundleSubsByName[name] = sub;
						}
					} else {
						state.cartSubs.push({
							subType: "yearly",
							name,
							fromCart: true,
							errors: [],
						});
					}
				}
			}
			// pre-select if coming from preselect URL
			const urlPath = window.location.pathname;
			const preselectedOption = /^\/online\/enroll-/.test(urlPath)
				? urlPath.substring(15)
				: null;
			if (preselectedOption) {
				const option = page.querySelector(
					`[data-subscription-type=${preselectedOption}]`
				);
				setTimeout(() => option && option.click(), 0);
			}
		}

		if (state.cartSubs.length) {
			for (let i = 0; i < state.cartSubs.length; i++) {
				setupSubRow(state.cartSubs[i], cartRowsContainer);
			}
		}

		// Set up add row listener
		addRow
			.querySelector(".ba11-p-enroll-sub-add-row-content")
			.addEventListener("click", evt => {
				addSubscription(getSubTypeFromSelectedIndex(state.selectedOptionIndex));
			});

		// Set up select options
		const selectOptionIndex = function(selectedIndex) {
			state.selectedOptionIndex = selectedIndex;
			subscriptionOptions.forEach((option, i) => {
				toggleClass(option, "--selected", i === selectedIndex);
				setInnerHtmlIfDiff(
					option.querySelector(".ba11-subscription-option-select"),
					i === selectedIndex ? "selected" : "select"
				);
			});
			update();
		};

		const setupSelectOption = function(optionClicked, index) {
			const selectFunc = function(evt) {
				if (state.selectedOptionIndex !== index) {
					selectOptionIndex(index);

					const subType = optionClicked.getAttribute("data-subscription-type");
					if (getSubCount() === 6) {
						// do nothing (subscriptions maxed)
					} else if (state.newSubs.length === 0) {
						createSubscription({subType});
					} else {
						modifySubscription(subType);
					}

					scrollToEl(stepTwo);
				} else {
					selectOptionIndex(-1);
				}
			};

			// Wire up select function to clicks and the select button
			const selectButton = optionClicked.querySelector(
				".ba11-subscription-option-select"
			);
			optionClicked.addEventListener("click", selectFunc);
			onEnter(selectButton, selectFunc);
		};
		subscriptionOptions.forEach((option, i) => setupSelectOption(option, i));

		// Add to cart functionality
		const addToCartFunc = function() {
			if (state.newSubs.length === 0) {
				window.location.href = "/checkout/cart";
				return;
			}
			state.hasAttemptedSubmit = true;
			const isValid = validateSubs(state);
			update();
			if (isValid) {
				modifyCart(c => {
					const addSubToTempCart = sub => {
						const items = getItemsForSubscription(sub);
						addItemsToCart(items, c);
					};

					state.newSubs.forEach(sub => addSubToTempCart(sub));
				});

				const numSubs = state.newSubs.length;
				const bundlesOnly = state.newSubs.every(sub => {
					return sub.subType === "bundle";
				});

				while (state.newSubs.length) {
					// Remove old sub from new subscriptions and recreate asgenerate cart subscription
					const subToMove = state.newSubs[0];
					subToMove.el.remove();
					delete subToMove.el;
					state.newSubs.shift();
					subToMove.fromCart = true;
					state.cartSubs.push(subToMove);
					setupSubRow(subToMove, cartRowsContainer);
				}
				update();

				showAddToCartModal(
					numSubs,
					bundlesOnly ? "bundle" : "subscription",
					addToCartButton
				);
			}
		};
		onClickOrEnter(addToCartButton, addToCartFunc);

		update();
	};

	initialSetup();
}

function getItemsForSubscription(sub) {
	const items = [];

	if (sub.subType === "bundle") {
		for (let b = 0; b < sub.selectedBundles.length; b++) {
			const bundleID = "bundle-grade-" + sub.selectedBundles[b];
			const skus = dbShopBundle[bundleID].skus;
			for (let skuIndex = 0; skuIndex < skus.length; skuIndex++) {
				const sku = skus[skuIndex];
				const item = {
					sku,
					quantity: 1,
					options: {
						bundleID: bundleID,
					},
				};
				if (sku !== "beast-yearly") {
					items.push(item);
				} else {
					item.options.displayName = sub.name;
					items.push(item);
				}
			}
		}
	} else {
		items.push({
			sku: "beast-" + sub.subType,
			quantity: 1,
			options: {
				displayName: sub.name,
			},
		});
	}

	return items;
}

module.exports = {
	setupEnrollPage,
};
